// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"607":"2831d364392fd8d8","660":"991e3c567721f07b"}[chunkId] + ".js";
};